import { render, staticRenderFns } from "./DismissProduct.vue?vue&type=template&id=4f74a7ca&scoped=true"
import script from "./DismissProduct.vue?vue&type=script&lang=js"
export * from "./DismissProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74a7ca",
  null
  
)

export default component.exports